import 'css-chunk:src/feature/provision/TerminalSelect.module.scss';export default {
  "select": "TerminalSelect_select"
};